import { useTranslation } from "react-i18next";

export default function TrustSection() {
  const { t } = useTranslation();

  const stats = [
    { number: "10.000+", label: t("trust.stat1_label") },
    { number: t("trust.stat2_number"), label: t("trust.stat2_label") },
    { number: t("trust.stat3_number"), label: t("trust.stat3_label") },
    { number: t("trust.stat4_number"), label: t("trust.stat4_label") },
    { number: t("trust.stat5_number"), label: t("trust.stat5_label") },
  ];

  return (
    <section id="sobre" className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="w-full lg:w-1/2">
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-[1.15] mb-6">
              {t("trust.title_line1")}
              <br />
              {t("trust.title_line2")}
            </h2>
            <div className="grid grid-cols-3 gap-0">
              {stats.slice(0, 3).map((stat, i) => (
                <div
                  key={i}
                  className={`flex flex-col items-start px-3 py-4 ${i < 2 ? "border-r border-background-200/70" : ""}`}
                >
                  <span className="text-3xl md:text-4xl font-black text-primary-500 font-heading leading-none">
                    {stat.number}
                  </span>
                  <span className="text-xs md:text-sm text-foreground-500 mt-2 leading-tight max-w-[120px]">
                    {stat.label}
                  </span>
                </div>
              ))}
            </div>
            <div className="grid grid-cols-2 gap-0 border-t border-background-200/70 mt-0">
              {stats.slice(3, 5).map((stat, i) => (
                <div
                  key={i}
                  className={`flex flex-col items-start px-3 py-4 ${i === 0 ? "border-r border-background-200/70" : ""}`}
                >
                  <span className="text-3xl md:text-4xl font-black text-primary-500 font-heading leading-none">
                    {stat.number}
                  </span>
                  <span className="text-xs md:text-sm text-foreground-500 mt-2 leading-tight max-w-[120px]">
                    {stat.label}
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div className="w-full lg:w-1/2 relative overflow-hidden rounded-2xl min-h-[350px]">
            <img
              src="https://readdy.ai/api/search-image?query=Minimalist%20workspace%20scene%20with%20laptop%20on%20warm%20beige%20wooden%20desk%20fashion%20moodboard%20on%20wall%20above%20with%20fabric%20swatches%20and%20color%20palette%20small%20potted%20plant%20coffee%20cup%20soft%20natural%20morning%20light%20from%20large%20window%20calm%20organized%20creative%20space%20editorial%20interior%20photography%20warm%20neutral%20earthy%20tones%20serene%20productive%20atmosphere%20Scandinavian%20design%20aesthetic%20no%20text&width=800&height=600&seq=trust-section-image-v2&orientation=landscape"
              alt="Espaço de trabalho criativo - Planilha Hoobuy"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
            <div className="absolute bottom-6 left-6 right-6 bg-background-50/90 backdrop-blur-sm rounded-2xl p-5">
              <div className="w-12 h-12 mb-3 rounded-full bg-accent-100 flex items-center justify-center">
                <i className="ri-shield-star-line text-2xl text-accent-600"></i>
              </div>
              <p className="text-sm md:text-base text-foreground-800 font-medium leading-relaxed">
                Cada produto é verificado manualmente antes de entrar na planilha. Qualidade garantida para você comprar com total confiança.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}